export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";